import React, { useEffect, useState } from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link as RouterLink, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import FileCopyIcon from "@mui/icons-material/FileCopyOutlined";
import { Grid, IconButton, Tooltip } from "@mui/material";

export const LinkRouter = (props) => <Link {...props} component={RouterLink} />;

export default function PathWay({ isCustom }) {
  const [pathNames, setPathNames] = useState(null);
  const { id } = useParams();
  const paths = useSelector((state) => state.sidebar.paths);
  const urlBase = `${window.location.origin}/Reports/Layout/${id}`;

  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  const handleOpen = () => setOpen(true);

  const { pathname } = useLocation();

  useEffect(() => {
    if (paths && id && paths[id]) {
      let path = paths[id].split("/").filter((x) => x);

      setPathNames(path);
    }
  }, [paths, id]);

  const handleCopy = () => {
    let url = isCustom ? window.location : urlBase;

    if (navigator.clipboard !== undefined) {
      //Chrome
      navigator.clipboard.writeText(url).then(
        function () {
          setOpen(true);
          setTimeout(function () {
            handleClose();
          }, 1500);
        },
        function (_err) {},
      );
    } else if (window.clipboardData) {
      // Internet Explorer
      window.clipboardData.setData("Text", url);
      setOpen(true);
      setTimeout(function () {
        handleClose();
      }, 1500);
    }
  };

  return (
    <Grid
      container
      alignItems="center"
      direction="row"
      justify="flex-start"
      wrap="nowrap"
      sx={{ minWidth: 0 }}
    >
      <Breadcrumbs aria-label="breadcrumb">
        <LinkRouter color="inherit" to="/">
          Home
        </LinkRouter>
        {!isCustom &&
          pathNames &&
          pathNames.map((value, index) => {
            return <Typography key={`BreadCrumb-Item-${value}-${index}`}>{value}</Typography>;
          })}
        {isCustom && (
          <Typography key={`BreadCrumb-Item-${pathname}`}>
            {pathname?.substring(1) ?? ""}
          </Typography>
        )}
      </Breadcrumbs>
      <Tooltip title="Copy Url to Clipboard">
        <IconButton size={"small"} style={{ margin: "0px 4px 0px 8px" }} onClick={handleCopy}>
          <Tooltip
            arrow
            disableFocusListener
            disableHoverListener
            disableTouchListener
            PopperProps={{
              disablePortal: true,
            }}
            open={open}
            title="Copy Succesfully"
            onClose={handleClose}
            onOpen={handleOpen}
          >
            <FileCopyIcon fontSize="small" style={{ color: "rgba(255, 255, 255, 0.7)" }} />
          </Tooltip>
        </IconButton>
      </Tooltip>
    </Grid>
  );
}
